module.exports = __webpack_public_path__ + "img/vertical_4_2_1.a6b3c831.png";